import { useMemo } from 'react';
import {
  selectCreditLimitReached,
  selectCreditWarningReached,
  selectPaygCreditLimitReached,
  selectPaygCreditWarningReached
} from 'src/redux/slices/auth';
import { useSelector } from 'src/redux/store';
import { CREDITS_POOL_STATE } from 'src/types/enum';

export interface CreditsPoolStates {
  plan: CREDITS_POOL_STATE;
  payg: CREDITS_POOL_STATE;
}

const toCreditsPoolState = (
  isLimitReached: boolean,
  isNearingLimit: boolean
): CREDITS_POOL_STATE =>
  isLimitReached
    ? CREDITS_POOL_STATE.LIMIT_REACHED
    : isNearingLimit
    ? CREDITS_POOL_STATE.NEARING_LIMIT
    : CREDITS_POOL_STATE.OK;

export const useCreditsPoolStates = (): CreditsPoolStates => {
  const planIsNearingLimit = useSelector(selectCreditWarningReached);
  const planIsLimitReached = useSelector(selectCreditLimitReached);
  const paygIsNearingLimit = useSelector(selectPaygCreditWarningReached);
  const paygIsLimitReached = useSelector(selectPaygCreditLimitReached);

  return useMemo(
    () => ({
      plan: toCreditsPoolState(planIsLimitReached, planIsNearingLimit),
      payg: toCreditsPoolState(paygIsLimitReached, paygIsNearingLimit)
    }),
    [
      planIsLimitReached,
      planIsNearingLimit,
      paygIsLimitReached,
      paygIsNearingLimit
    ]
  );
};
